(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'vcRecaptchaService', '$window', 'APP_VERSION'];

    function LoginController ($rootScope, $state, $timeout, Auth, vcRecaptchaService, $window, appVersion) {
        var vm = this;

 		$rootScope.$on('$viewContentLoaded', function(){
             angular.element(document).find('body').addClass('register-open')
          });

        vm.appVersion = appVersion;
        vm.authenticationError = false;
        //vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        vm.reCaptchaPublicKey = reCaptchaPublicKey;
        vm.reCaptchaSize = 'invisible';
        vm.recaptchaResponse = false;
       /* if (angular.element($window).width() < 460) {
            vm.reCaptchaSize = 'compact';
        }*/

        $timeout(function (){angular.element('#username').focus();});

        $timeout(function () {
            grecaptcha.execute()
        }, 1000);

        setInterval(function(){ grecaptcha.reset(); }, 1 * 60 * 1000 );

        /*function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
           // $uibModalInstance.dismiss('cancel');
        }*/

        function login (event) {
            //event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                authClient.signIn({username:vm.username, password:vm.password})
                    .then(function(res) {
                        if (res.status === 'SUCCESS') {
                            authClient.token.getWithRedirect({
                                sessionToken: res.sessionToken,
                                responseType: 'id_token'
                            });
                        }
                    }).fail(function(err) {
                    console.error(err);
                });
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
           // $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
           // $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
